<div class="grid grid-cols-1 gap-5">

  <app-latest-posts
    [posts]="posts"
    [maxSidebarCards]="maxCards"
    [naPlaceholder]="naPlaceholder"
    (viewPost)="viewRow($event)">
  </app-latest-posts>

  <app-latest-alerts
    [alerts]="alerts"
    [maxSidebarCards]="maxCards"
    [naPlaceholder]="naPlaceholder"
    (viewAlert)="viewAlert($event)">
  </app-latest-alerts>

</div>